import React, { useEffect, useState } from "react";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { Link, NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader/Loader";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";
import { StoreInfoAPI } from "../../Utils/Api/UserProfile";
import { userId } from "../../Utils/LocalStorage";
import EditNewLocationNew from "../EditNewLocationNew/EditNewLocationNew";
import Navigation from "../Navigation/Navigation";
import { getBusinessSwitched } from "../../Utils/LocalStorage";

const MyProfileStoreInfoPage = () => {
  const [storeInfoFlag, setStoreInfoFlag] = useState(false);
  const [refreshFlagStore, setRefreshFlagStore] = useState(false);
  const [currentTab, setcurrentTab] = useState("");
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [loading, setLoading] = useState(false);

  const path = window.location.href;
  const endPath = path.split("/");

  useEffect(() => {
    if (endPath[4] === "store-info") {
      setcurrentTab("storeinfo");
    }
  }, []);

  const Bu_id = userId();

  ////////////////////////////Store Info////////////////////////////////
  const RefreshFlagStore = (val) => {
    setRefreshFlagStore(val);
  };

  const GetStoreInfoAPI = async () => {
    let val = {
      bu_id: parseInt(Bu_id),
      api_method: "get",
    };
    setLoading(true);
    const getStoreInfoData = await StoreInfoAPI(val);
    if (getStoreInfoData.status === 429) {
      setLoading(true);
      toast.error(getStoreInfoData.message, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
    setStoreInfoFlag(getStoreInfoData.success);
    setLoadingFlag(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  useEffect(() => {
    GetStoreInfoAPI();
  }, [refreshFlagStore]);

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to={"/dashboard"}>
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>
          <p className="page-maintitle">My Profile</p>
          <div className="acc-dashboard mt-4">
            <div className="mb-2 tabs_ul">
              <NavLink to={"/my-profile/general-info"} className={"tabs_li"}>
                General Info
              </NavLink>
              <NavLink to={"/my-profile/business-info"} className={"tabs_li"}>
                Business Info
              </NavLink>
              <NavLink
                to={"/my-profile/store-info"}
                className={
                  currentTab === "storeinfo" ? " activeTab" : "tabs_li"
                }
              >
                Store Info
              </NavLink>
              <NavLink to={"/my-profile/subscription"} className={"tabs_li"}>
                Subscription
              </NavLink>
              {/* <NavLink to={"/my-profile/bank-info"} className={"tabs_li"}>
                Bank Info
              </NavLink> */}
              {/* <NavLink
                to={"/my-profile/transaction-history"}
                className={"tabs_li"}
              >
                Transaction History
              </NavLink> */}
              <NavLink
                to={"/my-profile/marketplace-membership"}
                className={"tabs_li"}
              >
                Marketplace Membership
              </NavLink>
              {getBusinessSwitched() === "false" && (
                <NavLink to="/my-profile/manage-business" className={"tabs_li"}>
                  Manage Businesses
                </NavLink>
              )}
            </div>

            <div className="mt-3">
              {loadingFlag === true ? (
                // storeInfoFlag === true ? (
                // <EditNewLocation />
                <EditNewLocationNew />
              ) : (
                // ) : (
                //   <AddNewLocation RefreshFlagfunc={RefreshFlagStore} />
                // )
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
      <PrivacyTermsConditions />
    </>
  );
};

export default MyProfileStoreInfoPage;
